import WebServiceRequest from "../../Api/WebServiceRequest";

class PlanGetRequest extends WebServiceRequest {
  constructor(context) {
    super(context);
  }
  setId(id) {
    super.setTag("Plan/Get?planId=" + id);
  }
}
export default PlanGetRequest;
